import {ProductComboProvider} from '@/context/ProductCombo/ProductComboContext'
import {CreateProductCombo as CreateProductComboNorthAmerica} from '@/features/ProductCombo/CreateProductCombo'
import {selectCountryCode} from '@/store/slices/countryCodeSlice'
import {NEW_THEME_FEATURE_COUNTRIES} from '@/utils/constants/marketFeatureCountries'
import {useSelector} from 'react-redux'
import {CreateProductCombo} from './CreateProductCombo'

/**
 * Reusable Product Combo editor shell backed by ProductCombo context.
 * @param {{
 *   initialState?: import('@/types/productComboTypes').ProductCombo,
 *   initialStep?: number,
 * }} props
 * @returns {JSX.Element}
 */
export const ProductComboEditor = ({initialState, initialStep}) => {
  const countryCode = useSelector(selectCountryCode)

  return (
    <ProductComboProvider initialState={initialState} initialStep={initialStep}>
      {NEW_THEME_FEATURE_COUNTRIES.includes(countryCode) ? <CreateProductComboNorthAmerica /> : <CreateProductCombo />}
    </ProductComboProvider>
  )
}
